import React from 'react'

import BasePreviewContent from './Base'

function PreviewContent({ PreviewComponent = BasePreviewContent, ...props }) {
  return <PreviewComponent {...props} />
}

export default PreviewContent
